import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

const SubServicio1FormGroup = ({ iError, iTouched, fIsSubmitting, vIdServicio }) => {
  const [subServicios1, setSubServicios1] = React.useState([])

  React.useEffect(() => {
    if (vIdServicio) {
      TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.TALLERSUBSERVICIO1, {
        _idServicio: vIdServicio
      }).then(({ data }) => setSubServicios1(data))
    } else {
      setSubServicios1([])
    }
  }, [vIdServicio])

  return (
    <Form.Group>
      <Form.Label text='SUB SERVICIO 1' htmlFor='select-idSubServicio1' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idSubServicio1'>
          {({ field }) => (
            <Form.Select {...field} id='select-idSubServicio1' isInvalid={iTouched && iError} disabled={fIsSubmitting}>
              <option value=''>Seleccionar</option>
              {subServicios1.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SubServicio1FormGroup)
